<template>
  <div>
        <el-tabs type="border-card">

            <el-tab-pane label="我的购买记录">
                <div>
                    <el-button size='mini' type="info" plain @click="onRefer">刷新</el-button>
                    <el-form :inline="true" :model="dataForm" class="demo-form-inline" size="mini" ref="dataForm">
                        <el-form-item prop="user" >
                            <el-input v-model="dataForm.user" placeholder="请输入名称关键词"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onSearchUpload(0)">查询</el-button>
                        </el-form-item>
                        <el-form-item>
                            <el-button @click="resetForm('dataForm')" type="primary" plain>重置</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div>
                    <el-table ref="multipleTable" :data="tableDatas" tooltip-effect="dark" border @selection-change="handleSelectionChange">
                        <el-table-column align="center" type="selection"></el-table-column>
                        <el-table-column align="center" type=index label="序号"></el-table-column>
                        <el-table-column align="center" prop="VAttachmentName" show-overflow-tooltip label="附件名称"></el-table-column>
                        <el-table-column align="center" prop="VAttachmentNumber"   label="图片编号"></el-table-column>
                        <el-table-column align="center" prop="price"   label="价格"></el-table-column>
                        <el-table-column align="center" prop="remark"   label="备注"></el-table-column>
                        <el-table-column align="center" prop="imgCopyrightName"   label="版权人"></el-table-column>
                        <el-table-column align="center" prop="createdTime"   label="购买时间"></el-table-column>


                    </el-table>
                    <el-pagination
                        background
                        @current-change="handleCurrentChange"
                        :page-sizes="[10]"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total='totalCount'
                        class="sorter">
                    </el-pagination>
                </div>
            </el-tab-pane>

        </el-tabs>
  </div>
</template>

<script>
import { getUser, removeUser} from "./../../../../untils/auth.js"
export default {
    name:'mypicbuy',
    data() {
        return {
            totalCount:0,
            dataForm:{
                user:''
            },
            tableDatas: []
        }
    },
    created() {
        this.eduDataRes('','0')
    },
    methods: {
        resetForm(e) {
            this.$refs[e].resetFields();
          this.eduDataRes('','0')
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        handleCurrentChange(val) {
            console.log(val);
            this.eduDataRes('',val);
        },
        // 上传资料跳转
        onUploadRes (){
            this.$router.push({
                path: 'picUpload',
            })
        },
        // 查询已上传的资料
        onSearchUpload (current){
            this.axios.post(window.IPConfig.IP + '/tBPrivateImage/queryPage.do',
            {
                VAttachmentName: this.dataForm.user,
                current: current,
                size: '10',
                imgCopyright:JSON.parse(getUser()).principal.VUserId,
            }
            ).then((response) => {
                if (response.status == 200) {
                  if(response.data.obj){
                    this.tableDatas = response.data.obj;
                    this.totalCount = response.data.total;
                  }else{
                    this.$message({
                      message: '无数据',
                      type: 'error'
                    })
                  }
                }
            })
        },
        // 已上传资料
        eduDataRes (type,current){
            this.axios.post(window.IPConfig.IP + '/tBPrivateImage/queryPage.do',
            {
                imgCopyright: JSON.parse(getUser()).principal.VUserId,
                current: current,
                size: '10',
            }
            ).then((response) => {
                if (response.status == 200) {
                    if (response.data.status == 200) {
                        if(response.data.obj){
                            this.tableDatas = response.data.obj;
                            this.totalCount = response.data.total;
                        }else{
                            this.$message({
                                message: '无数据',
                                type: 'error'
                            })
                        }
                    }
                }
            })
        },

        // 刷新
        onRefer(){
            this.eduDataRes('','0')
        }
    }
}
</script>

<style lang="stylus" scoped>
.demo-form-inline {
    float:right
}
.sorter {
  text-align:center;
  margin-top: 0.1rem;
}
.el-table .cell, .el-table td {
  padding: none !important;
}

// 状态的三种颜色样式
.color1{
  color: #5fb878
}
.color2{
  color: #ffb800
}
.color3{
  color: red
}

</style>



// WEBPACK FOOTER //
// src/components/Personalcenter/components/my/mypicbuy.vue